import React, { PureComponent, Fragment } from 'react';
import { withTranslation } from 'react-i18next';

import { Picture } from 'formlabs-web-components/Media';
import { Grid, Cell } from 'formlabs-web-components/Grid';
import { Header, Eyebrow } from 'formlabs-web-components/Type';
import { Button } from 'formlabs-web-components/Link';
import { DisplayComponent } from 'formlabs-web-components/BaseComponents';
import './Blog.module.css';
const FeaturedBlogPost = DisplayComponent(
  class FeaturedBlogPost extends PureComponent {
    render() {
      const { post, classes, t } = this.props;
      return (
        <Fragment>
          {post && (
            <Grid direction="x" className={classes}>
              <Cell largeSize={12}>
                <Picture largeImage={post.listing_image} fullBleed={true} />
              </Cell>
              <Cell
                largeSize={12}
                backgroundColor="blue"
                contentAlignment="align-children-middle"
              >
                <Cell>
                  <Grid direction="x">
                    <Cell
                      largeSize={16}
                      largeOffset={4}
                      smallSize={20}
                      smallOffset={2}
                    >
                      <div styleName="featured-copy">
                        <Eyebrow>{post.category.name}</Eyebrow>{' '}
                        <Eyebrow>{post.pub_date}</Eyebrow>
                        <div styleName="featured-title">
                          <Header level={2} displayAs={4}>
                            {post.title}
                          </Header>
                        </div>
                        <Button to={post.url} arrow="right" color="white">
                          {t('Learn More')}
                        </Button>
                      </div>
                    </Cell>
                  </Grid>
                </Cell>
              </Cell>
            </Grid>
          )}
        </Fragment>
      );
    }
  }
);

FeaturedBlogPost.propTypes = {};

export default withTranslation()(FeaturedBlogPost);
